"use strict";
import * as fabric from "fabric";
import printQueue from "../printQueue.js";
window.APP = window.APP || {};
APP.LabelPrintView = Backbone.View.extend({
  template: _.template($("#screen7Template").html()),
  initialize: function (options) {
    this.brandid = window.data.get("brand");
    this.labelurl = window.previewImage;
    this.gender = window.data.get("gender");
    if (this.brandid == "") {
      this.brandid = 3;
      window.data.set("brand", 1);
      window.data.set("name", "Shelby");
      window.data.set("gender", "female");
      this.gender = "female";
      this.name = "Shelby";
    }
  },
  // populate the html to the dom
  render: function () {
    this.$el.html(this.template({ brandid: this.brandid, labelurl: this.labelurl }));

    setTimeout(() => {
      $(".screen--print .button-container__button--print").on("click", async (e) => {
        e.preventDefault();
        
        // Registrar el click de impresión (online o offline)
        try {
          await printQueue.recordPrint();
          console.log('Print click registered successfully');
        } catch (error) {
          console.error('Error registering print click:', error);
        }
        
        $(".loader").show();
        $(".screen--print .button-container__button--print").hide();
        const imagen = await this.generatePrintImage();
        const frame = document.createElement("iframe");

        const printstyle = `
            @page {
              margin: 0;
              size: 4in 6in;
              size: portrait;
            }
            @media print {
              body > * {
                display:none;
                max-width: 100mm;
              }
              html {
                width: 100mm;
                border-top: 0;
                height:150mm;
              }
              body > img {
                display: block;
                border: none;
                width: 100mm !important;
                height: 150mm !important;
                position: absolute;
                top: 0;
                left: 0;
                margin: 0;
                padding: 0;
              }
            }
            html, body {
              margin:0;
              padding:0;
              width:100mm;
              height:150mm;
            }
            img {
              display: block;
              border: none;
              width: 100mm !important;
              height: 150mm !important;
              position: absolute;
              top: 0;
              left: 0;
              margin: 0;
              padding: 0;
            }`;
        const external_doc = new Blob([`<html><body><style>${printstyle}</style><img src="${imagen}"></html></body>`], {
          type: "text/html",
        });
        frame.onload = function () {
          app.navigate("inicio", { trigger: true });
          try {
            this.contentWindow && this.contentWindow.print();
          } catch (err) {
            console.error("Could not print from iframe.", err);
          }
        };
        frame.src = URL.createObjectURL(external_doc);
        document.body.appendChild(frame);
      });
      //window.data.set({ name: "", gender: "", brand: 1, user_name: "", user_email: "" });
    }, 100);
    return this;
  },
  generatePrintImage: async function () {
    const canvas = new fabric.Canvas("printCanvas");
    try {
      // Forzar la carga de la fuente antes de usarla
      await document.fonts.load('bold 120px Mermaid');
      
      // Verificar que la fuente esté disponible
      const fontAvailable = document.fonts.check('bold 120px Mermaid');
      console.log('Mermaid font available:', fontAvailable);

      // Cargar imagen base
      const img = await fabric.FabricImage.fromURL("images/offline/base.png");
      img.set({
        left: 0,
        top: 0,
      });
      canvas.add(img);
      
      // Cargar imagen de crucero
      const cruImg = await fabric.FabricImage.fromURL("images/offline/brand_" + this.brandid + "_cru.png");

      cruImg.set({
        left: canvas.width / 2,
        top: canvas.height / 2,
        originX: "center",
        originY: "center",
      });
      //canvas.add(cruImg);
      
      // add text to canvas (centered)
      let name = window.data.get("name").trim().substring(0, 6);
      const textCenterX = 740;
      const text = new fabric.FabricText(name, {
        left: textCenterX,
        top: 739,
        fontFamily: "Mermaid",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: 120,
        fill: "black",
        originX: "center",
        originY: "center",
        charSpacing: -50,
      });
      
      // Obtener el ancho final del texto
      console.log('Print Text width:', text.width);
      console.log('Print Text bounding rect:', text.getBoundingRect());
      
      // Calcular posición de la imagen de género alineada con el texto centrado
      const textBounds = text.getBoundingRect();
      const gender = window.data.get("gender");
      const genderImgWidth = gender === "female" ? 279 : 228;
      const genderImgLeft = textBounds.left - genderImgWidth - 15; // 15px de separación
      
      canvas.add(text);
      
      // Cargar imagen de género
      console.log("Loading gender image for print");
      console.log("Gender for label:", gender);
      
      const genderImg = await fabric.FabricImage.fromURL("images/offline/" + gender + ".png");
      genderImg.set({
        left: genderImgLeft,
        top: 690,
      });
      canvas.add(genderImg);
      
      // Renderizar canvas
      canvas.renderAll();
      // Obtener dataURL
      const dataURL = canvas.toDataURL({
        format: "png",
        quality: 1.0,
      });
      return dataURL;
    } catch (err) {
      console.error("Failed to load image in fabric:", err);
      throw err;
    }
  },
});
